module.exports = __webpack_public_path__ + "img/person_1.fb06ffa9.jpg";